import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-c330d032"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "appQuestionModal" }

import { ref } from "vue";
import API from "@/api";
import { getAppQuestionAndOptionUsingGet } from "@/api/appController";
import message from "@arco-design/web-vue/es/message";

/**
 * 定义组件属性类型
 */
interface Props {
  appId: string;
  appName: string;
}

/**
 * 给组件指定初始值
 */

export default /*#__PURE__*/_defineComponent({
  __name: 'AppQuestionModal',
  props: {
    appId: { default: () => "" },
    appName: { default: () => "" }
  },
  setup(__props: any, { expose: __expose }) {

const props = __props;

const visible = ref(false);
const openModal = () => {
  loadData();
  visible.value = true;
};

const closeModal = () => {
  visible.value = false;
};
__expose({
  openModal,
});
const appQuestionOption = ref<API.AppQuestionAndOptionVO[]>();
/**
 * 加载数据
 */
const loadData = async () => {
  if (!props.appId) {
    return;
  }
  const res = await getAppQuestionAndOptionUsingGet({
    appId: props.appId as any,
  });
  if (res.data.code === 200) {
    appQuestionOption.value = res.data.data as any;
  } else {
    message.error("获取数据失败，" + res.data.message);
  }
};

return (_ctx: any,_cache: any) => {
  const _component_a_list_item_meta = _resolveComponent("a-list-item-meta")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_list_item = _resolveComponent("a-list-item")!
  const _component_a_list = _resolveComponent("a-list")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_a_modal, {
      visible: visible.value,
      "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((visible).value = $event)),
      onCancel: closeModal,
      footer: false,
      fullscreen: "",
      title: _ctx.appName
    }, {
      default: _withCtx(() => [
        (appQuestionOption.value)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (appQuestionOption.value)
                ? (_openBlock(), _createBlock(_component_a_list, {
                    key: 0,
                    data: appQuestionOption.value,
                    bordered: false
                  }, {
                    item: _withCtx(({ item, index }) => [
                      (_openBlock(), _createBlock(_component_a_list_item, { key: index }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_list_item_meta, {
                            title: item.question.questionName
                          }, null, 8, ["title"]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.optionList, (option, optionIndex) => {
                            return (_openBlock(), _createElementBlock("div", { key: optionIndex }, [
                              _createVNode(_component_a_space, null, {
                                default: _withCtx(() => [
                                  _createTextVNode(_toDisplayString(option.optionKey) + ". " + _toDisplayString(option.optionName) + " " + _toDisplayString(option.optionResult), 1)
                                ]),
                                _: 2
                              }, 1024)
                            ]))
                          }), 128))
                        ]),
                        _: 2
                      }, 1024))
                    ]),
                    _: 1
                  }, 8, ["data"]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["visible", "title"])
  ]))
}
}

})